import React from "react";

import { getPercentOptions } from "../../utils/getPercentOptions";
import DensitySelect from "../DensitySelect";

export default function AudienceAgeDensitySelect({
  selectedAudienceAgeDensity,
  onChangeAudienceAgeDensity,
  isDisabled,
}) {
  const options = getPercentOptions(100);

  return (
    <DensitySelect
      selectedDensity={selectedAudienceAgeDensity}
      options={options}
      onChange={onChangeAudienceAgeDensity}
      dataAttr="audience-age-density"
      isDisabled={isDisabled}
    />
  );
}
